import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import {
  isMultipleFileUploadConfig,
  type MultipleFileUploadConfig,
} from '../type/file-upload-config';

@Pipe({
  name: 'isMultipleFileUploadConfig',
})
export class IsMultipleFileUploadConfigPipe implements PipeTransform {
  transform(config: unknown): config is MultipleFileUploadConfig {
    return isMultipleFileUploadConfig(config);
  }
}
